@use "../../mixins" as *;
@use "../../variables" as *;

.matching-products {
  .headline {
    margin-left: 1.25rem;
    margin-bottom: 1rem;
    font-size: 1.5rem;
    line-height: 1.75rem;
    color: $grey-text;

    @include tablet {
      margin-left: 0;
      margin-bottom: 2rem;
      font-size: 2.75rem;
      line-height: 3rem;
    }
  }

  .slider {
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    overflow-y: hidden;
    width: 100vw;

    > div {
      &:first-child {
        margin-left: 0;
        padding-left: 1.25rem;
      }

      &:last-child {
        margin-right: 0;
        padding-right: 1.25rem;
      }
    }
  }

  .products {
    display: flex;
    flex-wrap: wrap;

    @include tablet {
      justify-content: space-between;
    }
  }

  .product {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    width: 60%;
    max-width: 60%;
    margin-bottom: 5rem;
    cursor: pointer;

    @include tablet {
      width: calc(33% - 0.5rem);
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 1.5rem;
      display: block;
      flex: none;
    }
  }

  .hidden {
    visibility: hidden;
  }

  .fill-container {
    height: 50vh;
  }
}